import { TableRow, TableCell } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';
import SalesManageStaticsTableCell from './SalesManageStaticsTableCell';

const SalesManageStaticsHeadquarterRow = ({ data, headerRows }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((com, comIndex) => {
      return com?.children.map((hq, hIndex) => (
        <TableRow key={hIndex}>
          {hIndex === 0 && (
            <TableCell
              rowSpan={com.rowSpan}
              colSpan={com?.id === 'total' ? '2' : undefined}
              sx={{ width: '100px' }}
            >
              {com.name}
            </TableCell>
          )}
          {com?.name !== hq?.name && (
            <TableCell sx={{ width: '150px' }}>{hq.name}</TableCell>
          )}
          <TableCell sx={{ width: '100px' }} align="right" padding="none">
            {getNumberComma(hq?.yearBudget)}
          </TableCell>
          <SalesManageStaticsTableCell
            data={hq?.data}
            headerRows={headerRows}
          />
        </TableRow>
      ));
    })
  );
};

export default SalesManageStaticsHeadquarterRow;
